module.exports = __webpack_public_path__ + "img/header-content-bg.ed788d69.jpg";